var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home-header"},[_c('div',{staticClass:"center-con"},[_c('Header')],1)]),_c('div',{staticClass:"container"},[_c('div',{staticClass:"main-content"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }